<template>
  <v-container
    fluid
    id="container"
    class="mx-auto overflow-hidden pa-0 white"
    color="white"
    tile
    elevation="0"
  >
    <div class="text-end primary d-flex">
      <div>
        <v-btn
          v-if="this.isWaitingApprove"
          @click="commitOrders"
          :loading="this.approving"
          :disabled="this.approving"
          class="mt-3 mx-2 rounded-tl-0"
          rounded
          color="white"
        >
          {{ $t("generic.lang_is_last_order") }}
        </v-btn>
        <h6
          v-if="enableAllYouCanEatMode && !isAycePerGroupMode"
          class="py-2 px-5 my-4 font-weight-bold lighten-3 text-start"
        >
          {{ $t("generic.lang_nextOrderIn") }}: {{ timeForNextOrder }}
        </h6>
      </div>
      <v-spacer></v-spacer>
      <div>
        <h6 class="py-2 px-5 my-4 font-weight-bold lighten-3">
          <span v-if="!isReadonly"
            >{{ $t("generic.lang_tableNo") }} {{ this.table }}</span
          >
        </h6>
      </div>
    </div>
    <!--Start NavBar-->
    <Header />
    <!--End NavBar-->
    <v-row class="primary pt-3 pb-6">
      <v-col cols="12">
        <v-row no-gutters align="center" justify="center">
          <v-col cols="11" xs="11" sm="11" class="pl-0 white--text">
            <h5 v-if="!this.isReadonly" class="font-weight-bold text-h5">
              Hey, {{ this.party }}!
            </h5>
            <h5 class="" v-html="this.Messages.menu_page"></h5>
          </v-col>
          <!--Start Notification Badge-->
          <!-- <v-col cols="3" xs="3" sm="3" class="pl-9">
            <v-badge
              :content="notification"
              :value="notification"
              color="white"
              overlap
              class="mx-auto"
            >
              <v-icon color="white" size="30">
                mdi-bell-outline
              </v-icon>
            </v-badge>
          </v-col>-->
          <!--End Notification Badge-->
        </v-row>
      </v-col>
      <!--Start Search input-->
      <!--<v-col cols="12" class="pl-7 pr-7">
        <v-text-field
          :placeholder="$t('generic.lang_searchDishes')"
          dense
          outlined
          color="white"
          v-model="search"
          autocomlete="false"
          hide-details
        >
          solo-inverted
          <template v-slot:append>
            <v-btn
              fab
              dark
              elevation="0"
              x-small
              color="transparent"
              @click="isShowingFilter = true"
              id="filter_icon"
            >
              <v-icon dark color="white" size="24px">
                mdi-tune
              </v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </v-col>-->
      <!--End Search input-->
      <!--Start Filter info-->
      <!--      <v-col cols="3" xs="3" sm="3" class="pr-6 text-right">
              <v-btn
                  fab
                  dark
                  elevation="0"
                  x-small
                  color="tertiary lighten-3 pa-5 mb-1"
                  @click="isShowingFilter = true"
              >
                <v-icon dark color="primary" size="24px">
                  mdi-tune
                </v-icon>
              </v-btn>
            </v-col>-->
      <!--  Start filter component  -->
      <filter-component
        v-if="false"
        v-model="isShowingFilter"
        v-bind:dialog="isShowingFilter"
      />
      <!--  End filter component  -->
      <!--End Filter info-->
    </v-row>
    <!--Start Products Menu-->
    <menu-items v-bind:search="this.search" />
    <!--End Products Menu-->

    <!-- No Payment Methods Dialog -->
    <v-dialog
      v-model="noPaymentsDialog"
      persistent
      max-width="400"
      style="z-index: 10"
    >
      <v-card>
        <v-card-title class="pa-1">
          <v-spacer></v-spacer>
          <v-btn icon @click="noPaymentsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="headline black--text text-center mt-3">
          {{ $t("generic.lang_noPaymentMethodsActivePleaseContactServer") }}
        </v-card-text>

        <v-card-actions>
          <v-btn
            @click="callWaiter"
            :disabled="calling_waiter"
            :loading="calling_waiter"
            class="mb-3 mx-auto"
            rounded
            color="primary"
          >
            {{ this.$t("generic.lang_call_waiter") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
/*import: components*/
import Header from "@/components/Widget/Header.vue";
import menuItems from "@/components/Menu/menuItems.vue";
/*import: plugins*/
import { createNamespacedHelpers } from "vuex";
import FilterComponent from "@/components/Menu/FilterComponent";
import ENDPOINTS from "@/plugins/axios/endpoints";

export default {
  components: { FilterComponent, Header, menuItems },
  computed: {
    ...createNamespacedHelpers("Order").mapGetters(["isWaitingApprove"]),
    ...createNamespacedHelpers("Table").mapGetters(["table", "party"]),
    ...createNamespacedHelpers("Config").mapGetters([
      "Messages",
      "isReadonly",
      "enableAllYouCanEatMode",
      "timeForNextOrder",
      "payments",
      "isAycePerGroupMode"
    ]),
    ...createNamespacedHelpers("Table").mapGetters({
      party: "party",
      table_uuid: "uuid",
      table_name: "table"
    }),
    /*sync search input with vuex*/
    search: {
      get() {
        return this.$store.getters["Filter/search"];
      },
      set(val) {
        this.$store.commit("Filter/setSearch", val);
      }
    }
  },
  watch: {
    payments: {
      handler(newVal) {
        if (newVal.length === 0) {
          this.noPaymentsDialog = true;
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      notification: 0,
      isShowingFilter: false,
      tab: null,
      approving: false,
      noPaymentsDialog: false,
      calling_waiter: false
    };
  },
  methods: {
    ...createNamespacedHelpers("Order").mapMutations(["waitApprove"]),
    commitOrders() {
      this.approving = true;
      this.$axios
        .post(ENDPOINTS.SELF_SERVICE.ORDERS.TEMP_ORDERS.APPROVE, {
          tableName: this.table
        })
        .then(res => {
          //this.$router.push("/menu");
          //if ordering as group is enabled we have to indicate that this order is marked as last order in the table
          if (res.data.success) {
            this.waitApprove(false);
            this.$forceUpdate();
          } else {
            this.$swal({
              title: this.$t("errors.lang_cant_create_order"),
              text: this.$t("errors.lang_try_again"),
              icon: "error"
            });
          }
        })
        .catch(() => {
          this.$swal({
            title: this.$t("errors.lang_cant_create_order"),
            text: this.$t("errors.lang_try_again"),
            icon: "error"
          });
        })
        .finally(() => (this.approving = false));
    },
    callWaiter() {
      this.calling_waiter = true;
      this.$axios
        .post(window.ENDPOINTS.SELF_SERVICE.NOTIFY, {
          table: {
            uuid: this.table_uuid,
            name: this.table_name,
            party: this.party
          },
          type: 1,
          message: "",
          paymentType: null
        })
        .then(res => {
          if (res.data.success === true)
            this.$swal({
              title: this.$t("generic.lang_success"),
              text: this.$t("generic.lang_waiter_will_join_you"),
              icon: "success"
            });
        })
        .catch(() => {
          this.$swal({
            title: this.$t("errors.lang_try_again"),
            text: this.$t("generic.lang_cant_call_waiter"),
            icon: "error"
          });
        })
        .finally(() => {
          this.calling_waiter = false;
          this.noPaymentsDialog = false;
        });
    }
  }
};
</script>
<style scoped>
#container {
  height: 100% !important;
}

#filter_icon {
  position: absolute;
  right: 4px;
  top: 4px;
}
</style>
